export const DeviceSizes = {
    mobile: 480,
    tablet: 768,
    laptop: 1024,
    desktop: 1200,
}

// https://www.freecodecamp.org/news/css-media-queries-breakpoints-media-types-standard-resolutions-and-more/